module.exports = __webpack_public_path__ + "img/pp_logo.88f45255.png";